import cropr from "../../shared/utils/cropr";
import { Model } from "../../shared/utils/legacy";
import useCroprBackbone from "../../shared/hooks/useCroprBackbone";

const useRevenueDefinition = () => {
  if (!cropr.revenueDefinitions) {
    cropr.revenueDefinitions = new Model.RevenueDefinitionCollection();
    cropr.revenueDefinitions.fetch({ data: `plan=${cropr.getActivePlan().id}&limit=1000` });
  }
  return useCroprBackbone("revenueDefinitions");
};

export default useRevenueDefinition;
